import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 40 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Label = ({ children }) => (
  <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] font-semibold text-neutral-400">
    <span className="h-px w-8 bg-coral" aria-hidden="true" />
    {children}
  </span>
);
